import { useEffect, useState } from "react";
import {  pathMain } from "../../../common/config/vars";
import { AskQ, AskQCancel, AskQNotPressed, AskQOk } from "../../../common/ui/Popups/AskQuestion";
import { act_keyAccountId, act_keyRequestForAddPhone } from "../../../common/activities";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { queryAddSlave, queryDeniedAddSlave } from "../logics/setAccountAccess2slave";

interface ISetAccountAccess2slave {
  searchParams: object
}

//отрисовывает последнее начисление по текущему аккаунту
export const SetAccountAccess2slave = ({searchParams}: ISetAccountAccess2slave) => {
  const [askAccess, setAskAccess] = useState("")
  const [stateAskQ, setStateAskQ] = useState(AskQNotPressed)
  const [deniedLoading, setDeniedLoading] = useState(false)
  const [grantedLoading, setGrantedLoading] = useState(false)
  const [deniedSuccess, setDeniedSuccess] = useState("")
  const [deniedFail, setDeniedFail] = useState("")
  const [grantedSuccess, setGrantedSuccess] = useState("")
  const [grantedFail, setGrantedFail] = useState("")

  const history = useHistory()

  const resetStates = () => {
    setAskAccess("")
    setGrantedSuccess("")
    setGrantedFail("")
    setDeniedSuccess("")
    setDeniedFail("")
    setStateAskQ(AskQNotPressed)
  }
  useEffect(() => {
    resetStates()
    if(act_keyAccountId in searchParams && act_keyRequestForAddPhone in searchParams){
      //@ts-ignore
      setAskAccess(`Предоставить пользователю ${searchParams[act_keyRequestForAddPhone]} доступ к аккаунту ${searchParams[act_keyAccountId]} ?`)  
    }
  }, [searchParams])

  useEffect(() => {
    if(!deniedLoading){
      if(deniedFail != "") {
        toast.error(deniedFail)
        resetStates()
        return
      } else if(deniedSuccess != "") {
        toast.success(deniedSuccess)
        resetStates()
      }
    }

  }, [deniedLoading])

  useEffect(() => {
    if(!grantedLoading){
      if(grantedFail != "") {
        toast.error(grantedFail)
        resetStates()
        return
      } else if(grantedSuccess != "") {
        toast.success(grantedSuccess)
        resetStates()
      }
    }
  }, [grantedLoading])

  useEffect(() => {
    if(stateAskQ != AskQNotPressed){
      if(stateAskQ == AskQOk) {
        //@ts-ignore
        queryAddSlave({phone: searchParams[act_keyRequestForAddPhone], accountId: searchParams[act_keyAccountId], setFailMsg: setGrantedFail, setLoading: setGrantedLoading, setSuccessMsg: setGrantedSuccess })
        //history.push(pathMain)
      } else if(stateAskQ == AskQCancel) {
        //@ts-ignore
        queryDeniedAddSlave({phone: searchParams[act_keyRequestForAddPhone], accountId: searchParams[act_keyAccountId], setFailMsg: setDeniedFail, setLoading: setDeniedLoading, setSuccessMsg: setDeniedSuccess })
        //history.push(pathMain)
      } 
      history.replace(pathMain)
    }
  }, [stateAskQ])
  
  return (
    <>
    {askAccess != "" ? <AskQ title="Доступ к аккаунту" text={askAccess} setAskQ={setStateAskQ} btnOkText="Добавить" btnCancelText="Отказать" askQ={stateAskQ}  /> :<></>  }
    </>
  );
};
